import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import { usePWA } from '@/hooks/usePWA';

export const PWAInstallBanner: React.FC = () => {
  const { isInstallable, install } = usePWA();
  const [isVisible, setIsVisible] = useState(false);
  const [visits, setVisits] = useState(0);

  useEffect(() => {
    // Contar visitas
    const visitCount = parseInt(localStorage.getItem('pwa-visit-count') || '0');
    const newVisitCount = visitCount + 1;
    localStorage.setItem('pwa-visit-count', newVisitCount.toString());
    setVisits(newVisitCount);

    // Mostrar banner después de 3 visitas o 30 segundos
    const dismissed = localStorage.getItem('pwa-banner-dismissed');
    const lastDismissed = dismissed ? parseInt(dismissed) : 0;
    const daysSinceDismissed = (Date.now() - lastDismissed) / (1000 * 60 * 60 * 24);

    if (isInstallable && (!dismissed || daysSinceDismissed > 7) && newVisitCount >= 2) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 30000); // 30 segundos

      return () => clearTimeout(timer);
    }
  }, [isInstallable]);

  const handleInstall = async () => {
    await install();
    setIsVisible(false);
  };

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('pwa-banner-dismissed', Date.now().toString());
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-[calc(5rem+env(safe-area-inset-bottom))] right-4 z-50 max-w-[calc(100%-2rem)] sm:max-w-xs animate-fade-in">
      <div className="bg-gradient-to-r from-primary to-primary/80 rounded-xl p-3 shadow-elegant border border-primary/20">
        <div className="flex items-start gap-3">
          <div className="bg-white/20 p-1.5 rounded-lg">
            <Download className="w-4 h-4 text-white" />
          </div>
          <div className="flex-1">
            <p className="text-white text-sm font-medium">
              Instalar menú
            </p>
            <p className="text-white/80 text-xs">
              Acceso rápido y offline
            </p>
          </div>
          <button 
            onClick={handleDismiss}
            className="text-white/80 hover:text-white"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <button
          onClick={handleInstall}
          className="w-full mt-2 bg-white text-primary text-sm font-medium py-1.5 rounded-lg hover:bg-white/90 transition-colors"
        >
          Instalar
        </button>
      </div>
    </div>
  );
};
